"use client";

import { Box, Divider, Typography, IconButton, Tooltip } from "@mui/joy";
import { PanelLeftOpen, MessageSquare } from "lucide-react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import NotesWidget from "../../../../components/Notes";

export function Notes() {
    const [collapsed, setCollapsed] = useState(false);
    const { id } = useParams<{ id: string }>();

    if (!id) return null;

    return (
        <Box
            sx={{
                position: "sticky",
                top: 0,
                display: "flex",
                flexDirection: "column",
                bgcolor: "background.surface",
                height: "100%",
                flexShrink: 0,
            }}
            width={collapsed ? 48 : 360}
        >
            <Box
                className="sidebar-header"
                sx={{
                    px: collapsed ? 0 : 1.5,
                    py: 1.5,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: collapsed ? "center" : "space-between",
                    height: 56,
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    bgcolor: "background.level1",
                }}
            >
                {!collapsed && (
                    <Typography
                        level="title-sm"
                        sx={{
                            fontWeight: 800,
                            fontSize: "12px",
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            color: "text.primary",
                        }}
                    >
                        Notes & Feed
                    </Typography>
                )}

                <IconButton
                    variant="plain"
                    color="neutral"
                    size="sm"
                    onClick={() => setCollapsed((v) => !v)}
                    sx={{
                        borderRadius: "8px",
                    }}
                >
                    <PanelLeftOpen size={18} />
                </IconButton>
            </Box>

            {collapsed ? (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        flex: 1,
                        py: 2,
                        bgcolor: "background.surface",
                        cursor: "pointer",
                    }}
                    onClick={() => setCollapsed(false)}
                >
                    <Tooltip title="Expand Notes" placement="left" variant="soft">
                        <Box sx={{ opacity: 0.4 }}>
                            <MessageSquare size={20} />
                        </Box>
                    </Tooltip>
                </Box>
            ) : (
                <Box
                    sx={{
                        flex: 1,
                        overflow: "hidden",
                    }}
                >
                    <NotesWidget entityType="project" entityId={id} density="compact" hideHeader={true} />
                </Box>
            )}
        </Box>
    );
}
